import styled from 'styled-components'

export const Renderer = styled.canvas`
  width: 100%;
  max-width: 100vw;
  
  @media (min-width: 780px) {
    max-width: 640px;
  }
`

export const RendererContainer = styled.div`
  width: 640px;
  height: 360px;
  padding: 10px;
  background-color: #444;
  border-radius: 5px;
  box-shadow: 0 0 1px 3px rgba(0,0,0,.25);
  
  & > * {
    border-radius: 5px;
  }
`

export const Hidden = styled.div`
  position: absolute;
  overflow: hidden;
  z-index: -1;
  width: 10px;
  height: 10px;
  opacity: 0;
`


export const Loaders = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-around;
  
  @media (min-width: 780px) {
    flex-direction: row;
    flex-wrap: wrap;
    width: 100%;
    justify-content: center;
    
    & > div {
      margin: 0 10px;
      max-width: 400px;
    }
  }
  
  text-align: center;
    
  & > label > span {
    margin-bottom: 10px;
  }
`


export const Loader = styled.div`
  width: 100%;
  height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
`

export const Main = styled.main`
  display: flex;
  flex-direction: column;
  @media (min-width: 780px) {
    flex-direction: row;
  }
  
  justify-content: center;
`


export const DialogBody = styled.div`
  min-width: 30vw;
  padding: 10px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
`

export const Row = styled.div`
  display: flex;
  flex-direction: row;
  width: 100%;
  
  *:not(:last-child) {
    margin-right: 10px;
  }
`

export const VideoOverlay = styled.div`
  position: absolute;
  left: 0;
  top 0;
  text-align:center;
`

export const VideoContainer = styled.div`
  position: relative;
  text-align:center;
`



// WEBPACK FOOTER //
// ./src/styled.js